import { render, staticRenderFns } from "./GeneralModal.vue?vue&type=template&id=dcbc8130&scoped=true&"
import script from "./GeneralModal.vue?vue&type=script&lang=js&"
export * from "./GeneralModal.vue?vue&type=script&lang=js&"
import style0 from "./GeneralModal.vue?vue&type=style&index=0&id=dcbc8130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbc8130",
  null
  
)

export default component.exports